import React from 'react';
import { Link } from 'react-router-dom';

import classNames from 'classnames';
import { BackIcon } from 'fluxo-ui/icons';

interface PageHeaderProps {
    title: React.ReactNode;
    description?: React.ReactNode;
    actions?: React.ReactNode;
    backTo?: string;
    backLabel?: string;
    meta?: React.ReactNode;
    className?: string;
}

const PageHeader: React.FC<PageHeaderProps> = ({ title, description, actions, backTo, backLabel, meta, className }) => {
    return (
        <div className={classNames('mb-6', className)}>
            {backTo && (
                <Link
                    to={backTo}
                    className="inline-flex items-center gap-1.5 mb-2 text-sm text-slate-500 dark:text-slate-400 hover:text-slate-900 dark:hover:text-slate-200 transition-colors cursor-pointer"
                >
                    <BackIcon className="w-4 h-4" />
                    {backLabel || 'Back'}
                </Link>
            )}
            <div className="flex flex-wrap items-start justify-between gap-x-4 gap-y-3">
                <div className="min-w-0">
                    <div className="flex flex-wrap items-center gap-2.5">
                        <h1 className="text-xl sm:text-2xl font-bold tracking-tight text-slate-900 dark:text-white">{title}</h1>
                        {meta}
                    </div>
                    {description && <p className="mt-1 text-sm text-slate-500 dark:text-slate-400 max-w-2xl">{description}</p>}
                </div>
                {actions && <div className="flex flex-wrap items-center gap-2 shrink-0">{actions}</div>}
            </div>
        </div>
    );
};

export default PageHeader;
